if (typeof customElements.get("nays-bottom-sheet") === "undefined") {
  class NaysBottomSheet extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector(".sheet__panel");
      this.grip = this.querySelector("[data-sheet-grip]") || this.panel;
      this._lastFocus = null;
      this._dragStartY = 0;
      this._dragging = false;
      this._onKeydown = this._onKeydown.bind(this);
      this._move = this._move.bind(this);
      this._end = this._end.bind(this);
    }

    connectedCallback() {
      this.setAttribute("hidden", "");
      this.querySelectorAll("[data-sheet-dismiss]").forEach((el) =>
        el.addEventListener("click", () => this.close()),
      );
      this.grip.addEventListener("pointerdown", (e) => this._start(e));
    }

    open() {
      if (this.hasAttribute("open")) return;
      this._lastFocus = document.activeElement;
      this.removeAttribute("hidden");
      this.getBoundingClientRect(); // reflow so the transition runs
      this.setAttribute("open", "");
      document.documentElement.classList.add("sheet-lock");
      document.addEventListener("keydown", this._onKeydown);
      (this._focusables()[0] || this.panel).focus();
      this.dispatchEvent(new CustomEvent("sheet:open", { bubbles: true }));
    }

    close() {
      if (!this.hasAttribute("open")) return;
      this.removeAttribute("open");
      this.panel.style.transform = "";
      document.documentElement.classList.remove("sheet-lock");
      document.removeEventListener("keydown", this._onKeydown);
      const done = () => {
        this.setAttribute("hidden", "");
        this.panel.removeEventListener("transitionend", done);
      };
      this.panel.addEventListener("transitionend", done);
      if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
      this.dispatchEvent(new CustomEvent("sheet:close", { bubbles: true }));
    }

    toggle() {
      this.hasAttribute("open") ? this.close() : this.open();
    }

    _focusables() {
      return Array.from(
        this.panel.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        ),
      ).filter(
        (el) => !el.hasAttribute("disabled") && el.offsetParent !== null,
      );
    }

    _onKeydown(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        this.close();
        return;
      }
      if (e.key !== "Tab") return;
      const f = this._focusables();
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    _start(e) {
      if (e.button) return;
      this._dragging = true;
      this._dragStartY = e.clientY;
      this.panel.style.transition = "none";
      window.addEventListener("pointermove", this._move);
      window.addEventListener("pointerup", this._end);
    }

    _move(e) {
      if (!this._dragging) return;
      const dy = Math.max(0, e.clientY - this._dragStartY);
      this.panel.style.transform = `translateY(${dy}px)`;
    }

    _end(e) {
      this._dragging = false;
      this.panel.style.transition = "";
      window.removeEventListener("pointermove", this._move);
      window.removeEventListener("pointerup", this._end);
      const dy = Math.max(0, e.clientY - this._dragStartY);
      if (dy > 120) this.close();
      else this.panel.style.transform = "";
    }
  }

  customElements.define("nays-bottom-sheet", NaysBottomSheet);

  // Delegated triggers — works regardless of element upgrade timing.
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-sheet-open]");
    if (!t) return;
    e.preventDefault();
    const sheet = document.getElementById(t.getAttribute("data-sheet-open"));
    if (sheet && typeof sheet.open === "function") {
      t.setAttribute("aria-expanded", "true");
      sheet.open();
      sheet.addEventListener(
        "sheet:close",
        () => t.setAttribute("aria-expanded", "false"),
        { once: true },
      );
    }
  });
}
